/*
 * DJ CART v2 - 30 Oct 2026 (the 27 Sep promo-code field is gone: codes are
 * entered on Shopify's checkout page).
 *
 * 1. Keeps the "Your bag · N items" count in the drawer header current. The
 *    header is not re-rendered with the cart, so the count is read from the
 *    footer (data-item-count) each time the footer is replaced.
 * 2. Keeps the Klaviyo welcome popup from opening on its own timer while the
 *    cart has something in it - it was landing on top of the Checkout button
 *    right after Add to cart. A popup the shopper opens themselves (the
 *    teaser) still opens.
 */
(function () {
    "use strict";

    var lastIntent = 0;

    // --- Header count ------------------------------------------------------

    function syncCount() {
        var label = document.querySelector("[data-djc-count]");
        if (!label) return;
        var total = document.querySelector("#cart-sidebar-footer [data-item-count]");
        var n = total ? parseInt(total.getAttribute("data-item-count"), 10) || 0 : 0;
        label.textContent = n > 0 ? n + (n === 1 ? " item" : " items") : "";
    }

    function watchFooter() {
        var footer = document.getElementById("cart-sidebar-footer");
        if (!footer) return false;
        new MutationObserver(syncCount).observe(footer, { childList: true });
        syncCount();
        return true;
    }

    if (!watchFooter()) {
        document.addEventListener("DOMContentLoaded", watchFooter);
    }

    // --- Klaviyo popup vs the cart ---------------------------------------

    // A tap on any Klaviyo element (the teaser) counts as asking for the form.
    function noteIntent(event) {
        var t = event.target;
        if (t && t.closest && t.closest('[class*="kl-private"]')) {
            lastIntent = Date.now();
        }
    }
    document.addEventListener("pointerdown", noteIntent, true);
    document.addEventListener("keydown", noteIntent, true);

    function cartHasItems() {
        return !!document.querySelector("#cart-sidebar-footer [data-item-count]");
    }

    function closePopup(tries) {
        var btn = document.querySelector(
            '[role="dialog"][aria-label="POPUP Form"] button[aria-label="Close dialog"]'
        );
        if (btn) {
            btn.click();
            return;
        }
        if (tries > 0) {
            setTimeout(function () {
                closePopup(tries - 1);
            }, 100);
        }
    }

    window.addEventListener("klaviyoForms", function (event) {
        var detail = event.detail || {};
        if (detail.type !== "open") return;
        if (Date.now() - lastIntent < 2000) return;
        if (cartHasItems()) closePopup(20);
    });
})();
